import BirdnestSatelliteIcon from '@components/icons/BirdnestSatellite';
import ContactSupportButton from '@components/common/ContactSupportButton';
import PropTypes from 'prop-types';
import React from 'react';
import {Box, Container, Grid, Typography, styled} from '@mui/material';
import {ERROR_STATUS_MESSAGES} from '@account/utils/errors';

const StatusCode = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[500],
}));

const ErrorPage = ({statusMessage, statusCode, message}) => {
  return (
    <Box
      height="100%"
      display="flex"
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
    >
      <Container maxWidth="md">
        <Grid container spacing={4}>
          <Grid
            component={Box}
            item
            xs="auto"
            sm={4}
            display={{xs: 'none', sm: 'block'}}
          >
            <BirdnestSatelliteIcon />
          </Grid>

          <Grid item sm={8}>
            <Box display="flex" flexDirection="column" width="100%">
              {!!statusCode && (
                <StatusCode variant="h1" paragraph align="center" noWrap>
                  {statusCode}
                </StatusCode>
              )}

              <Box display="flex" flexDirection="column" width="100%">
                <Typography variant="h5" paragraph>
                  Houston, we have a problem...
                </Typography>

                <Typography color="textPrimary" gutterBottom>
                  {statusMessage ||
                    ERROR_STATUS_MESSAGES[statusCode] ||
                    'An error occurred, that we could not foresee.'}
                  {" We're sorry about that! "}
                </Typography>

                <Typography color="textPrimary" gutterBottom>
                  {statusCode === 404
                    ? 'Let us know if you think there is a problem on our side.'
                    : 'Try refreshing the page or let us know what happened, we are continuously working to improve your experience.'}
                </Typography>
              </Box>

              {import.meta.env.NODE_ENV === 'development' && message && (
                <Box
                  textAlign="left"
                  border={1}
                  borderColor="grey.300"
                  bgcolor="grey.100"
                  width="100%"
                  padding={2}
                >
                  <Typography variant="body2" gutterBottom>
                    <b>Message:</b> {message}
                  </Typography>
                </Box>
              )}
            </Box>

            <Box
              display="flex"
              width="100%"
              padding={2}
              marginTop={2}
              justifyContent="flex-end"
            >
              <ContactSupportButton />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

ErrorPage.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  statusMessage: PropTypes.string,
  message: PropTypes.string,
};

export default ErrorPage;
